import React from "react";

export const UsuariosPendientes = () => {
  return <div>UsuariosPendientes</div>;
};
